/* eslint-disable jsx-a11y/anchor-is-valid */
function APIDocumentation() {
  const handleOpenDocs = () => {
    window.open(`${process.env.REACT_APP_URL_API}/api-docs`, '_blank');
  };

  return (
    <p>
      <a
        href="#"
        onClick={handleOpenDocs}
        style={{
          cursor: 'pointer',
          color: 'blue',
          textDecoration: 'underline',
          marginTop: '20px', // Adicionando unidade de medida correta
          display: 'inline-block', // Garante que a margem funcione corretamente
        }}
      >
        Acesse a documentação da API
      </a>
    </p>
  );
}

export default APIDocumentation;
